// extracted by mini-css-extract-plugin
export default {"advertCardHeaderAction":"c-b_fn","advertCardHeaderAction__button":"c-b_fo","advertCardHeaderAction__label":"c-b_fp"};